<div class="c-overlay{{vm.theme ? ' c-overlay--s' + vm.theme : ''}}">
	<div class="c-loader"></div>
</div>
